import { render, staticRenderFns } from "./CourseItem.vue?vue&type=template&id=1405919d&scoped=true"
import script from "./CourseItem.vue?vue&type=script&lang=ts"
export * from "./CourseItem.vue?vue&type=script&lang=ts"
import style0 from "./CourseItem.vue?vue&type=style&index=0&id=1405919d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1405919d",
  null
  
)

export default component.exports